import { GaProductCardCartButton } from '../../molecules/cart-button'

import { useBehavior } from './scripts/composables'

// @vue/component
export default {
  name: 'ga-product-card-cart-adapter',

  components: {
    GaProductCardCartButton,
  },

  props: {
    data: {
      type: Object,
      default: () => ({}),
      required: true,
    },

    cancelDefaultAddToCart: {
      type: Boolean,
      default: false,
    },
  },

  emits: [
    'click-add-to-cart',
    'add-to-cart',
    'open-preview',
    'counter-increase',
    'counter-decrease',
  ],

  setup(props, { attrs, emit }) {
    const { cancelDefaultAddToCart, data } = toRefs(props)

    const { onCartClick, onIncrease, onDecrease } = useBehavior(
      data,
      cancelDefaultAddToCart,
      emit,
    )

    const propsToPass = computed(() => {
      const { data, cancelDefaultAddToCart, ...restProps } = attrs
      return restProps
    })

    return {
      propsToPass,

      onCartClick,

      onIncrease,
      onDecrease,
    }
  },
}
